import { useRef, useState } from "react";
import { Upload, Loader2, FileCheck2, X } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import WebcamCapture from "./WebcamCapture";

export default function DocUpload({ label, doc, setDoc, testid, error, capture }) {
  const [busy, setBusy] = useState(false);
  const [cam, setCam] = useState(false);
  const [noCam, setNoCam] = useState(false);
  const fileRef = useRef(null);
  const desktop = !noCam && typeof window !== "undefined" && !window.matchMedia("(pointer: coarse)").matches && !!navigator.mediaDevices?.getUserMedia;
  const upload = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) return toast.error("File too large, max 5MB");
    setBusy(true);
    try { const fd = new FormData(); fd.append("file", file); const r = await api.post("/auth/kyc-upload", fd); setDoc({ id: r.data.doc_id, name: file.name }); toast.success("Document uploaded"); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div>
      {doc ? (
        <div data-testid={`${testid}-uploaded`} className="flex items-center gap-2 rounded-xl border border-emerald-500/40 bg-emerald-500/10 px-3 py-2.5 text-sm">
          <FileCheck2 size={16} className="text-emerald-400 shrink-0" /><span className="truncate flex-1">{doc.name}</span>
          <button type="button" data-testid={`${testid}-remove`} onClick={() => setDoc(null)} className="p-1 rounded-full hover:bg-white/10"><X size={14} /></button>
        </div>
      ) : (
        <label onClick={(e) => { if (capture && desktop) { e.preventDefault(); setCam(true); } }} className="flex items-center gap-3 px-4 py-3 rounded-xl border border-dashed border-white/20 cursor-pointer hover:border-[#ff5500]/60">
          {busy ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} className="text-[#ff5500]" />}
          <span className="text-sm flex-1">{label}<span className="block text-[11px] text-slate-500">{capture ? "Opens your camera · only admin can see it" : "PDF, JPG or PNG · max 5MB · only admin can see it"}</span></span>
          <input ref={fileRef} data-testid={`${testid}-input`} type="file" accept={capture ? "image/*" : "application/pdf,image/jpeg,image/png"} capture={capture} hidden onChange={(e) => upload(e.target.files[0])} />
        </label>
      )}
      {error && <p data-testid={`${testid}-error`} className="text-xs text-red-400 mt-1">{error}</p>}
      {cam && <WebcamCapture testid={testid} onShot={upload} onClose={() => setCam(false)} onFail={() => { setCam(false); setNoCam(true); setTimeout(() => fileRef.current?.click(), 50); }} />}
    </div>
  );
}
